export default __webpack_public_path__ + "static/media/linkedin-circled-click.c508a5e8.gif";